import {createActionBarButtonAnchor} from '@github-ui/list-view/ListViewActionBar'
import {TriangleDownIcon} from '@primer/octicons-react'

import styles from './quick-filter-shared.module.css'

export type QuickFilterProps = {
  owner: string
  query: string
  repo: string
  onQueryChange: (query: string) => void
}

export function createQuickFilterAnchor(label: string) {
  return createActionBarButtonAnchor({
    children: label,
    className: styles.quickFilterButton,
    trailingVisual: TriangleDownIcon,
    'aria-label': `Filter by ${label.toLowerCase()}`,
  })
}
